import { render, staticRenderFns } from "./CentralOrderDetail.vue?vue&type=template&id=6d5be41f&scoped=true&"
import script from "./CentralOrderDetail.vue?vue&type=script&lang=js&"
export * from "./CentralOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./CentralOrderDetail.vue?vue&type=style&index=0&id=6d5be41f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5be41f",
  null
  
)

export default component.exports